<template>
  <div class="subMenuWrapper"
       v-on:click="goToSelectPage"
       v-bind:style="isSelected ? 'color: rgb(0,153,255);' : ''">
    <img class="iconImg" v-bind:src="iconImg">
    <span>{{spanText}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iconImg: require('@/assets/img/void_icon.png')
    }
  },
  props: {
    routerName: String,
    spanText: String,
    isSelected: Boolean
  },
  methods: {
    catchRedundant: function (err) {
      if (
        err.name !== 'NavigationDuplicated' &&
        !err.message.includes('Avoided redundant navigation to current location')
      ) {
        console.log(err)
      }
    },
    goToSelectPage: function () {
      this.$emit('selectedRouterName', this.routerName)
      this.$router.push({ name: this.routerName }).catch(this.catchRedundant)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span {
  font-size: 10px;
}
.subMenuWrapper{
  cursor: pointer;
  position: relative;
  display: flex;
  display: -ms-flexbox;
  justify-content:left;
  align-items: center;
  margin: 3px 10%;
  height: 40px;
  padding-left: 15px;
  border-radius: 0.3rem;
}

.iconImg {
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/elements/subMenu.vue